import React from 'react';
import withIcon from '../utilities/withIcon';

const IconTimer = () => {
  return (
    <g>
      <path d="m8.5977 2.1677v-.5823h1.1406a.75.75 0 1 0 0-1.5h-3.7813a.75.75 0 0 0 0 1.5h1.1407v.5846a6.9273 6.9273 0 0 0 -4.8177 2.7817 6.8959 6.8959 0 1 0 6.3177-2.784zm-.75 12.2468a5.3948 5.3948 0 1 1 5.3945-5.3945 5.401 5.401 0 0 1 -5.3945 5.3945z" />
      <path d="m10.0957 5.9941-1.5051 1.4938a1.9617 1.9617 0 1 0 1.0411 1.08l1.5206-1.5092a.75.75 0 1 0 -1.0566-1.0644zm-2.248 3.7715a.52.52 0 0 1 0-1.04.5184.5184 0 0 1 .52.52.5206.5206 0 0 1 -.52.52z" />
      <path d="m14.8272 3.3818-1.0372-1.0371a.75.75 0 0 0 -1.0605 1.0605l1.0371 1.0371a.75.75 0 0 0 1.0605-1.0605z" />
    </g>
  );
};

export default withIcon(IconTimer);
